import React, { useState } from "react";
import SvgImage from "../../../Icons/Icons";
import "./index.css";
import {
  downloadSalaryAction,
  downloadSalaryCreditSheet,
  uploadSalaryAction,
  uploadSalaryCreditSheet,
} from "../../../../services/Store/Actions/driverslistActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import {
  bulkTransferUpload,
  bulkWithdrawlUpload,
  downloadBulkTransferAction,
} from "../../../../services/Store/Actions/walletAction";
import { FormCheck } from "react-bootstrap";
import ShowExcel from "../ShowExcel";
import PinInput from "react-pin-input";
function BulkTransfer() {
  const [fileSave, setFileSave] = useState(null);
  const [loader, setLoader] = useState(false);
  const [bulkTransfer, setBulkTransfer] = useState(0);
  const [bulkTransferId, setBulkTransferId] = useState(null);
  const [isWithdraw, setIsWithdraw] = useState(false);
  const [pin,setPin] = useState('');
  const dispatch = useDispatch();
  const customId1 = "custom-id-download page";
  const notify1 = () =>
    toast.success("Template was downloaded successfully.", {
      toastId: customId1,
      pauseOnHover: false,
    });
  const customId2 = "custom-id-upload page";
  const notify2 = () =>
    toast.success("Transfer Driver Bulk updated successfully.", {
      toastId: customId2,
      pauseOnHover: false,
    });
  const customId3 = "custom-id-Salary-dispersed";
  const notify3 = () =>
    toast.success("Amount dispersed successfully to drivers.", {
      toastId: customId3,
      pauseOnHover: false,
    });
  const notify4 = () =>
    toast.success("Amount withdrawn successfully to Master Account.", {
      toastId: customId3,
      pauseOnHover: false,
    });
  const downloadSalDisbursement = () => {
    dispatch(
      downloadBulkTransferAction("", (res) => {
        console.log("downloadSalaryAction", res?.data);
        if (res?.status == 200) {
          const blob = new Blob([res?.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `file.xls`; //name to changed here
          link.click();
          notify1();
        }
      })
    );
  };
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const showModalAddDriver = () => {
    setModal(true);
  };

  const bulkTransferCall = () => {
    setLoader(true);
    if (isWithdraw) {
      dispatch(
        bulkWithdrawlUpload({ file: fileSave, bulkTransferId,pin:pin }, (res) => {
          console.log(res);
          setLoader(false);
          if (res.status == 200) {
            const blob = new Blob([res?.data]);
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `responseFile.xls`; //name to changed here
            link.click();
            notify4();
          } else {
            toast.error(res.data?.message || "some error occured");
          }
        })
      );
    } else {
      dispatch(
        bulkTransferUpload({ file: fileSave, bulkTransferId,pin:pin }, (res) => {
          console.log(res);
          setLoader(false);
          if (res.status == 200) {
            const blob = new Blob([res?.data]);
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `responseFile.xls`; //name to changed here
            link.click();
            notify3();
          } else {
            toast.error(res.data?.message || "some error occured");
          }
        })
      );
    }
  };
  console.log("isWithdrawisWithdrawisWithdraw", isWithdraw);
  return (
    <div style={{ width: "auto" }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            fontWeight: 600,
          }}
        >
          <FormCheck
            label={<span style={{ color: "green" }}>LOAD</span>}
            onChange={() => {
              setIsWithdraw(!isWithdraw);
            }}
            checked={!isWithdraw}
          ></FormCheck>
          <FormCheck
            label={<span style={{ color: "orange" }}>WITHDRAW</span>}
            onChange={() => {
              setIsWithdraw(!isWithdraw);
            }}
            checked={isWithdraw}
          ></FormCheck>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            className="col-lg-6"
            style={{ padding: "10px" }}
            onClick={downloadSalDisbursement}
          >
            <div className="svgContainerUp" style={{ margin: "0 23px" }}>
              <SvgImage name="Download" />
            </div>
            <div className="Bold300" style={{ textAlign: "center" }}>
              Download Template
            </div>
          </div>
          <div className="col-lg-6" style={{ padding: "10px" }}>
            <label for="file-upload2" class="custom-file-upload3">
              <input
                id="file-upload2"
                type="file"
                onChange={async (e) => {
                  const img = e?.target.files[0];
                  setFileSave(img);
                  console.log("image...", e?.target.files[0]);
                  setBulkTransfer(1);
                  notify2();
                }}
              />
              <div
                className="svgContainerUp"
                style={{
                  margin: "0px 23px",
                  backgroundColor: bulkTransfer > 0 ? "antiquewhite" : null,
                }}
              >
                <SvgImage name="Upload" />
              </div>
              <div className="Bold300" style={{ textAlign: "center" }}>
                Upload for bulk Transfers
              </div>
            </label>
          </div>
        </div>
      </div>
      {bulkTransfer == 1 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "-10px",
          }}
        >
          <div style={{ margin: ".5rem" }}>
            <a disabled={loader} style={{ margin: ".5rem" }} href={fileSave}>
              {fileSave?.name || "test"}
            </a>
            <a
              onClick={() => {
                console.log("ckisnkeddd");
                showModalAddDriver()
              }}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "blue",
              }}
            >
              View
            </a>
          </div>
          <div style={{}}>
            <input
              type="text"
              className=""
              name="bulkTransferId"
              placeholder="Enter Unique TransferId"
              disabled={loader}
              onChange={(e) => {
                console.log(e.target.value);
                setBulkTransferId(e.target.value);
              }}
            />
          </div>
          <ShowExcel
        toggle={toggleModal}
        modal={modal}
        setModal={setModal}
        fileSave={fileSave}
      />
          <div>
          <PinInput
                    length={4}
                    initialValue=""
                    secret
                    onChange={(val)=>{
                      // handleChange("pin")
                    console.log("val...",val)
                    setPin(val)
                    }}
                    type="numeric"
                    value={pin}
                    // onBlur={handleBlur("pin")}
                    // touched={touched.pin}
                    // errors={errors.pin}
                    inputMode="number"
                    style={{
                      marginTop: "20px",
                    }}
                    inputStyle={{
                      border: "1px solid #A7A7A7",
                      borderRadius: "8px",
                      marginRight: "5px",
                    }}
                    autoSelect={true}
                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                  />
            <Button
              className="greenButton"
              style={{ margin: ".5rem" }}
              onClick={bulkTransferCall}
              disabled={loader}
            >
              {" "}
              Transfer
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default BulkTransfer;
